import { Component } from '@angular/core';
import { ABNPipe } from "@shared/pipes/abnPipe";
import { ACNPipe } from "@shared/pipes/acnPipe";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import {
  IBulkAppliedChange
} from "../../../../../../forms/asic-forms/bulks/base-bulk-stepper-form/base-bulk-stepper-form.component";
import {
  EntityNameNumberRecordComponent
} from "@shared/components/commons/entity-name-number-record/entity-name-number-record.component";

type CellRendererParams = ICellRendererParams<IBulkAppliedChange>;

@Component({
  selector: 'app-ag-entity-name-acn-abn',
  standalone: true,
  imports: [
    EntityNameNumberRecordComponent,
  ],
  templateUrl: 'ag-entity-name-acn-abn.component.html',
})
export class AgEntityNameAcnAbnComponent implements ICellRendererAngularComp {
  name = '';
  entityNumberFormatted = '';
  entityIcon = '';

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.name = params.data?.name ?? '';
    this.entityNumberFormatted = this.formatEntityNumber(params.data?.entityNumber, params.data?.entityType);
    this.entityIcon = this.getEntityIcon(params.data?.entityType);

    return true;
  }

  formatEntityNumber(entityNumber: string | null | undefined, entityType: 'Company' | 'Trust' | null | undefined): string {
    if (!entityNumber || !entityType) return '';
    if (entityType == 'Company') return ACNPipe.formatValue(entityNumber);
    if (entityType == 'Trust') return ABNPipe.formatValue(entityNumber);
    return entityNumber.trim();
  }

  getEntityIcon(entityType: 'Company' | 'Trust' | null | undefined): string {
    if (entityType == 'Company') return 'ic-companies-20';
    if (entityType == 'Trust') return 'ic-trusts-20';
    return '';
  }
}
